export const fields = [
  "storyOfChange",
  "events",
  "subProgram",
  "precedingProgram",
  "resources",
  "blogs",
];

export const fieldData = {
  storyOfChange: {
    label: "Story of Change",
    apiRoute: "a1/organizations/blogs",
    idKey: "blogId",
    labelKey: "judulArtikel",
  },
  events: {
    label: "Events",
    apiRoute: "a1/organizations/events",
    idKey: "eventId",
    labelKey: "judulActivity",
  },
  subProgram: {
    label: "Sub Programs",
    apiRoute: "a1/organizations/programs",
    idKey: "programId",
    labelKey: "judulActivity",
  },
  precedingProgram: {
    label: "Preceding Programs",
    apiRoute: "a1/organizations/programs",
    idKey: "programId",
    labelKey: "judulActivity",
  },
  resources: {
    label: "Resources",
    apiRoute: "a1/organizations/resources",
    idKey: "resourceId",
    labelKey: "judulArtikel",
  },
  blogs: {
    label: "Blogs",
    apiRoute: "a1/organizations/blogs",
    idKey: "blogId",
    labelKey: "judulArtikel",
  },
};
